var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1.5H12.625V0.875C12.625 0.70924 12.5592 0.550268 12.4419 0.433058C12.3247 0.315848 12.1658 0.25 12 0.25C11.8342 0.25 11.6753 0.315848 11.5581 0.433058C11.4408 0.550268 11.375 0.70924 11.375 0.875V1.5H5.125V0.875C5.125 0.70924 5.05915 0.550268 4.94194 0.433058C4.82473 0.315848 4.66576 0.25 4.5 0.25C4.33424 0.25 4.17527 0.315848 4.05806 0.433058C3.94085 0.550268 3.875 0.70924 3.875 0.875V1.5H2C1.66848 1.5 1.35054 1.6317 1.11612 1.86612C0.881696 2.10054 0.75 2.41848 0.75 2.75V15.25C0.75 15.5815 0.881696 15.8995 1.11612 16.1339C1.35054 16.3683 1.66848 16.5 2 16.5H14.5C14.8315 16.5 15.1495 16.3683 15.3839 16.1339C15.6183 15.8995 15.75 15.5815 15.75 15.25V2.75C15.75 2.41848 15.6183 2.10054 15.3839 1.86612C15.1495 1.6317 14.8315 1.5 14.5 1.5ZM3.875 2.75V3.375C3.875 3.54076 3.94085 3.69973 4.05806 3.81694C4.17527 3.93415 4.33424 4 4.5 4C4.66576 4 4.82473 3.93415 4.94194 3.81694C5.05915 3.69973 5.125 3.54076 5.125 3.375V2.75H11.375V3.375C11.375 3.54076 11.4408 3.69973 11.5581 3.81694C11.6753 3.93415 11.8342 4 12 4C12.1658 4 12.3247 3.93415 12.4419 3.81694C12.5592 3.69973 12.625 3.54076 12.625 3.375V2.75H14.5V5.25H2V2.75H3.875ZM14.5 15.25H2V6.5H14.5V15.25Z",
    fill: "#F59E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookAppointment);
export default __webpack_public_path__ + "static/media/book-appointment.463be50f291462c4c3475e12752a4aa7.svg";
export { ForwardRef as ReactComponent };